/* eslint-disable array-callback-return */
import { DashboardListItems } from "../../../Store/Dashboard/types";
import moment from "moment";

export const DateAndTimeFromString = (input: string) => {
    // Split the input string into date and time components
    const year = input.slice(0, 4);
    const month = input.slice(4, 6);
    const day = input.slice(6, 8);
    const hours = input.slice(8, 10);
    const minutes = input.slice(10, 12);
    const seconds = input.slice(12, 14);

    // Format the date and time components
    const formattedDate = `${day}/${month}/${year}`;
    const formattedTime = `${hours}:${minutes}:${seconds}`;

    return {
        date: formattedDate,
        time: formattedTime,
        dateTime: formattedDate+"T"+formattedTime
    };
}

// const inputString = "20230717050148";
// const result = extractDateTime(inputString);
// console.log("Date:", result.date); // Output: Date: 17/07/2023
// console.log("Time:", result.time); // Output: Time: 05:01:48


export const OrderStatusSorting = (data: Array<DashboardListItems>) => {
    let delivered: Array<DashboardListItems> = [];
    let shipped: Array<DashboardListItems> = [];
    let ordered: Array<DashboardListItems> = [];
    let notOwned: Array<DashboardListItems> = [];

    if(data.length > 0) {
        data.map((item: DashboardListItems) => {
            switch (item.kiddoBandStatus) {
                case "Delivered": delivered.push(item)
                    break;
                case "Shipped": shipped.push(item)
                    break;
                case "Ordered": ordered.push(item)
                    break;
                case "Not owned": notOwned.push(item)
                    break;
                default:
                    break;
            }
        });
    }

    return {delivered, shipped, ordered, notOwned};
}

export const OrderDateSorting = (data: Array<DashboardListItems>) => {
    data.sort(function (a, b) {
        let d1 = moment(DateAndTimeFromString(b.orderDate).dateTime).unix();
        let d2 = moment(DateAndTimeFromString(a.orderDate).dateTime).unix();
        return d1 - d2;
    });
    return data.reverse();
}